export default __webpack_public_path__ + "static/media/activated_img_us.97067734.png";